import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  style: {"height":"90vh"},
  class: "ofs"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w100 title mc mt40" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, /*#__PURE__*/_toDisplayString(`カスタム権限を設定`))
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "w100 ofs noscroll",
  style: {"padding":"0px 40px 0 40px","height":"calc(100vh - 220px)"}
}
const _hoisted_5 = { class: "w100" }
const _hoisted_6 = { class: "fr" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "fs11 fw600 pad5 llgreyBg" }
const _hoisted_10 = {
  class: "fl",
  style: {"width":"300px","line-height":"50px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_17 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "キャンセル", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_21 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_LblueMiddleButton = _resolveComponent("LblueMiddleButton")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CustomPermissionModal",
    "content-class": "ofs modalContent shadowContent rad10 modalNormal posFi",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_ctx.po)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_LblueMiddleButton, {
                    buttonText: `管理者権限をもとに作成`,
                    name: `admin`,
                    onSelect: _ctx.clickAdminRoleTemplate
                  }, null, 8, ["onSelect"]),
                  _createVNode(_component_LblueMiddleButton, {
                    buttonText: `メンバー権限をもとに作成`,
                    name: `member`,
                    onSelect: _ctx.clickMemberRoleTemplate
                  }, null, 8, ["onSelect"]),
                  _hoisted_7
                ]),
                _hoisted_8
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.po), (opCategory) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "w100 mt20",
                  key: opCategory
                }, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.optionNames[opCategory]), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.po[opCategory]), (opName) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "ml20",
                      key: opName
                    }, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.optionNameDic[opCategory][opName].name), 1),
                      _createVNode(_component_SelectTag, {
                        name: "meeting_start_time",
                        id: `select_${opCategory}_${opName}`,
                        class: "fl fs14 roundForm noBorder",
                        style: {"width":"160px","height":"50px"},
                        returnVal: `${opCategory}::${opName}`,
                        options: _ctx.optionNameDic[opCategory][opName].types,
                        defaultOption: _ctx.defaultOption(_ctx.po[opCategory][opName], _ctx.optionNameDic[opCategory][opName].types),
                        onSelectValue: _ctx.selectOption
                      }, null, 8, ["id", "returnVal", "options", "defaultOption", "onSelectValue"]),
                      _hoisted_11
                    ]))
                  }), 128))
                ]))
              }), 128)),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ]))
          : _createCommentVNode("", true),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("section", {
            class: "llgreyBg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
          }, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePermissions && _ctx.changePermissions(...args)))
          }, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.action == `new` ? `招待メールを送信` : `変更`), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}